import React from 'react';
import './Separador.css'; // Ruta de importación al archivo CSS

const Separador = () => {
  return <div className="separador"></div>;
};

export default Separador;
